import {useState} from "react";
import {useTranslation} from "react-i18next";
import {Status} from "../../../models/enums";
import {OnSuccess} from "../../../utils/CallbackUtils";
import {apiInstance} from "../../../api/api";
import NotificationService from "../../../services/NotificationService";
import LoggerService from "../../../services/LoggerService";
import {useInvalidateSymbolQueries} from "./useInvalidateSymbolQueries";

interface UseDeleteSymbolPackHook {
	deleteStatus: Status,
	deleteSymbolPack: (symbolPackId: string, onSuccess: OnSuccess) => void;
}

function useDeleteSymbolPack(): UseDeleteSymbolPackHook {

	const {t} = useTranslation();
	const [deleteStatus, setDeleteStatus] = useState(Status.IDLE);
	const {invalidateSymbolQueries}= useInvalidateSymbolQueries();

	function deleteSymbolPack(symbolPackId: string, onSuccess: OnSuccess) {
		setDeleteStatus(Status.LOADING);
		apiInstance.symbolsApi.deleteSymbolPack(symbolPackId)
			.then(() => {
				onSuccess();
				invalidateSymbolQueries()
				setDeleteStatus(Status.SUCCESS);
				NotificationService.successNotification(t("common.success"),
					t("settings.tabs.symbols.packs.dropdown.delete.success"));
			})
			.catch((err: any) => {
				setDeleteStatus(Status.ERROR);
				NotificationService.errorNotification(t("common.error"),
					t("settings.tabs.symbols.packs.dropdown.delete.errorDesc"));
				LoggerService.logError(err);
			})
	}

	return {deleteStatus, deleteSymbolPack}
}

export default useDeleteSymbolPack;
